module.exports = __webpack_public_path__ + "img/tayun-night-balanced.c24ba51b.png";